var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatsiginline = function SvgStatsiginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#194B7D",
    fillRule: "evenodd",
    d: "M15.927 8a.25.25 0 0 1 0 .25l-3.855 6.626a.25.25 0 0 1-.216.124H4.144a.25.25 0 0 1-.216-.124L.073 8.25a.25.25 0 0 1 0-.252l3.855-6.625a.25.25 0 0 1 .216-.124h7.712a.25.25 0 0 1 .216.124z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 0.386,
    d: "m12.769 5.602-2.187.518 1.292 1.527z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m3.89 9.746 2.786-2.418 1.796 2.005 2.803-2.462"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.869 10.811c.618 0 1.119-.495 1.119-1.105 0-.611-.501-1.106-1.12-1.106-.617 0-1.118.495-1.118 1.106 0 .61.5 1.105 1.119 1.105"
  })));
};
export default SvgStatsiginline;